import React from 'react';
import { mockData } from '../data/mock';
import { LeaderCard } from './about/LeaderCard';
import { AboutStats } from './about/AboutStats';

const About = () => (
  <section className="py-24 bg-gradient-to-br from-gray-50 to-white" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium mb-4">
          About Us
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Who We Are</h2>
        <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
          AssetWise Business Consultants is a trusted financial and real estate advisory firm dedicated to helping individuals and businesses achieve their financial goals. We specialize in providing customized loan solutions along with expert guidance in property acquisition and legal processes.
        </p>
      </div>

      <div className="mb-16">
        <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">Our Leadership</h3>
        <div className="grid md:grid-cols-2 gap-12">
          {mockData.about.leaders.map((leader) => (
            <LeaderCard key={leader.name} leader={leader} />
          ))}
        </div>
      </div>

      <div className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-8 md:p-12 text-center mb-16 border border-cyan-100">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
          {mockData.about.mission}
        </p>
      </div>

      <AboutStats stats={mockData.stats} />
    </div>
  </section>
);

export default About;
